export default "__VITE_ASSET__oox9CoNv__"